import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'

import { getPartnerFlagsById } from '../api/getPartnerFlagsById'
import { selectPartnerFlags } from '../selectors'

export const useGetPartnerFlags = (partnerId: string) => {
  const dispatch = useAppDispatch()
  const { accreditation, program, agreement, status, message, meta } = useSelector(
    selectPartnerFlags,
    shallowEqual
  )

  const fetchPartnerFlags = useCallback(
    (isForce?: boolean) => {
      const options: ICrudFetchOptions = {
        cacheKey: partnerId,
        isForce,
        paging: { pageSize: 1000, page: 0 },
      }
      dispatch(getPartnerFlagsById({ partnerId, options }))
    },
    [dispatch, partnerId]
  )

  useEffect(() => {
    if (!meta || meta.arg?.['partnerId'] !== partnerId) {
      fetchPartnerFlags()
    }
  }, [partnerId, meta, dispatch, fetchPartnerFlags])

  return { accreditation, agreement, program, status, message, fetchPartnerFlags }
}
